export const OUTLAW_QUERY_PARAMS = {
  filmID: 'filmID',
  playlistID: 'playlistID',
  referralId: 'referral_id',
  videoToken: 'video_token',
  token: 'token',
  flow: 'flow',
  channelID: 'channelID',
  creatorID: 'creatorID',
  userID: 'userID',
  shareUserID: 'share_user_id',
  profileID: 'profileID',
  competitionID: 'competitionID',
  customPassID: 'customPassID',
  forgotPassword: 'forgot-password',
  interests: 'interests',
  social_name: 'social_name',
  promocode: 'promocode',
  subscribeAfter: 'subscribe_after',
  returnTo: 'return',
  typeOfEnter: 'type_of_enter',
  theme: 'theme',
  uuid: 'uuid',
  subscribe: 'subscribe',
  key: 'key',
  postId: 'postId',
  post_id: 'post_id',
  backwardsUrl: 'backwards_url',
};
